import { ReactNode } from "react";

import { formatExtractionStatus } from "../../../models/reportExtraction";

const STATUS_STYLES: Record<string, string> = {
  succeeded: "bg-green-100 text-green-800 border-green-200",
  running: "bg-blue-100 text-blue-800 border-blue-200",
  pending: "bg-stone-100 text-stone-700 border-stone-200",
  failed: "bg-red-100 text-red-800 border-red-200",
};

export interface Soc1DocumentHeaderProps {
  reportName: string | null;
  status: string | null;
  actions?: ReactNode;
}

export const Soc1DocumentHeader = ({
  reportName,
  status,
  actions,
}: Soc1DocumentHeaderProps) => {
  const title = reportName ?? "SOC 1 Report Extraction";
  const statusClass =
    (status && STATUS_STYLES[status]) ??
    "bg-stone-100 text-stone-700 border-stone-200";

  return (
    <header className="flex flex-col gap-3 pb-4 border-b border-stone-200">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <h1 className="text-xl font-semibold text-stone-900 break-words">
            {title}
          </h1>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${statusClass}`}
          >
            {formatExtractionStatus(status)}
          </span>
          {actions}
        </div>
      </div>
    </header>
  );
};
